module.exports = "<div class=\"select-option\">\n  <p-dropdown [options]=\"selectOption\" [(ngModel)]=\"selectedData\" name=\"selectedData\" (onChange)=\"getOption($event)\" [scrollHeight]=\"100\"\n    [placeholder]=\"placeHolder\"></p-dropdown>\n</div>\n\n\n<!-- [appendTo]=\"'body'\" -->\n"


//////////////////
// WEBPACK FOOTER
// /data/wwwroot/xzhipin/app-client/src/app/user/select-option/select-option.component.html
// module id = ../../../../../src/app/user/select-option/select-option.component.html
// module chunks = common